const featuredContentPanelClass = ".featured-content-panel";

function createfeaturedContentPanels() {
  function init() {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(featuredContentPanelClass).forEach((panel) => {
        createSingleFeaturedContentPanel(panel).init();
      });
    });
  }
  return { init };
}

function createSingleFeaturedContentPanel(panel) {
  let activeIndex = 0;
  let labels;
  let contents;
  let contentContainer;

  function init() {
    labels = Array.from(
      panel.querySelectorAll(
        `${featuredContentPanelClass}__labels-list-item-button`
      )
    );
    labels.forEach((button) => {
      button.addEventListener("click", () => {
        setActiveContent(parseInt(button.dataset.labelIndex));
      });
    });
    contents = Array.from(
      panel.querySelectorAll(`${featuredContentPanelClass}__content`)
    );
    contentContainer = panel.querySelector(
      `${featuredContentPanelClass}__content-container`
    );

    if (!labels || !contents || !contentContainer) return;

    contentContainer.addEventListener("transitionend", (e) => {
      e.stopPropagation();
      contentContainer.style.overflow = "auto";
      contentContainer.style.height = "auto";
    });

    initLabelGradients();
  }

  function initLabelGradients() {
    const labelsContainer = document.querySelector(`${featuredContentPanelClass}__labels`);
    const firstLabel = labels[0];
    const lastLabel = labels[labels.length - 1];

    const labelsObserverConfig = {
      root: labelsContainer,
      rootMargin: "0px",
      threshold: 0.99,
    };
  
    const labelsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isFirstLabel = parseInt(entry.target.dataset.labelIndex) === 0;
        const labelContainerClass = isFirstLabel ? 'at-end' : 'at-start';
        if (entry.isIntersecting) {
          labelsContainer.classList.remove(labelContainerClass);
        } else {
          labelsContainer.classList.add(labelContainerClass);
        }
      });
    }, labelsObserverConfig);
    labelsObserver.observe(firstLabel);
    labelsObserver.observe(lastLabel);
  }

  function setActiveContent(nextIndex) {
    handleContentStyleUpdates(nextIndex);
    handleLabelStyleUpdates(nextIndex);

    activeIndex = nextIndex;
  }

  function handleContentStyleUpdates(nextIndex) {
    const currentContent = contents.find(
      (content) => parseInt(content.dataset.contentIndex) === activeIndex
    );
    const nextContent = contents.find(
      (content) => parseInt(content.dataset.contentIndex) === nextIndex
    );

    if (!currentContent || !nextContent) {
      return;
    }

    contentContainer.style.overflow = "hidden";
    contentContainer.style.height = `${
      currentContent.getBoundingClientRect().height
    }px`;
    
    currentContent.classList.remove("active-content");
    nextContent.classList.add("active-content");
    contentContainer.style.height = `${
      nextContent.getBoundingClientRect().height
    }px`;
  }

  function handleLabelStyleUpdates(nextIndex) {
    const currentLabel = labels.find(
      (content) => parseInt(content.dataset.labelIndex) === activeIndex
    );
    const nextLabel = labels.find(
      (content) => parseInt(content.dataset.labelIndex) === nextIndex
    );

    if (!currentLabel || !nextLabel) {
      return;
    }

    currentLabel.classList.remove("active-label");
    currentLabel.setAttribute("aria-selected", false);
    nextLabel.classList.add("active-label");
    nextLabel.setAttribute("aria-selected", true);
  }

  return { init };
}

const featuredContentPanels = createfeaturedContentPanels();
featuredContentPanels.init();
